<template>
    <div id="addAppediton" class="app-inner">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
             @click="onSubmit('ruleForm')" 
            v-if="$route.query.type== 1"
            >
                保存
            </el-button>
            </div>
             <div class="edit-from">
         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  应用名称：{{$route.query.appName}}
            </div>
             </div>

             <el-form ref="ruleForm" :model="form" label-width="120px" :rules="rules" class="">
              
                 <el-form-item label="版本号：" prop="versionNum">
                    <el-input v-model="form.versionNum" placeholder="请输入版本号【1-30】" clearable
                    minlength="1"
                    maxlength="30"
                    :disabled=" $route.query.type== 2 ? true : false"
                    ></el-input>
                </el-form-item>
                 <el-form-item label="应用地址：" prop="versionNum" v-if="$route.query.appType==2 && $route.query.type==2">
                    <el-input v-model="form.resourceUrl" clearable
                    disabled
                    ></el-input>
                </el-form-item>
                 <el-form-item label="版本类型：" prop="versionType">
                  <el-radio v-model="form.versionType" label="1"  >PC端</el-radio>
                    <el-radio v-model="form.versionType" label="2">移动端</el-radio>
                </el-form-item>
                  <el-form-item label="更新资源包：" :prop="$route.query.appType!=2 ? 'resourceUrl' : ''" 
                  v-if="$route.query.appType!=2"
                  >
                      <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="headers"
                    :data="dataObj"
                    accept=".7z,.rar,.zip,.apk"
                    drag
                    :file-list="fileList"
                    :on-change="handleChangePic"
                    :disabled=" $route.query.type== 2 ? true : false"
                    :on-error="uploadError"
                    :on-remove="handleRemove1"
                    :before-upload="beforeUploadFun"
                    :on-success="handleAvatarSuccess1"
                    >
                     <i class="el-icon-upload" ></i>
                     <div class="el-upload__text" v-if="$route.query.type==1 ">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__text" v-if="$route.query.type==2">仅查看</div>
                     <div slot="tip" class="el-upload__tip" v-if="$route.query.type==1 ">支持格式：<span style="color:#f56c6c">rar、zip、7z</span></div>
                     <div slot="tip" class="el-upload__tip" v-if="$route.query.type==2">已上传资源地址：<span style="color:#f56c6c">{{form.resourceUrl}}</span></div>
                    </el-upload>
                </el-form-item>
                 <el-form-item label="发布信息：" prop="message" class="el-ipt-quill">
                    <el-input
                        type="textarea"
                        :rows="6"
                        placeholder="请填写发布信息"
                        v-model="form.message"
                        :disabled="$route.query.type == 2 ? true:false"
                        >
                        </el-input>
                    <!-- <quillTemplate  @sendStatus="emitFun" :propData="form.message"
                    :noneboo="$route.query.type== 2 ? false : true"
                    v-if="flag"
                    ref="quillTemplate"
                    ></quillTemplate> -->
                 </el-form-item>
             </el-form>
             </div>
    </div>
</template>
<script>  
import { appAllfun,policy} from "@/api/index/index"  //新增版本、版本详情、版本回退 请求方式不一样
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import quillTemplate from "@/components/quill/index.vue"; //将应用列表页面作为组件使用
export default {
    name:'addAppediton',
    components: {
    quillTemplate,
    },
    data() {
        return {
            uploadUrl:'',
            dataObj:{
                policy:'',
                signature:'',
                ossaccessKeyId:'',
                key:'',
                dir:'',
                host:'',
                callback:''
            },
            loading:false,
            appId:'',
            infolist:{},
            headers:{},
            fileList:[],
            flag:false,
            form:{
                versionNum:'',
                resourceUrl:'',
                message:'',
                versionType:''
            },
            rules:{
                  versionNum: [{ required: true, message: '请正确输入', trigger: 'blur' }],
                  resourceUrl:[{ required: true, message: '请上传资源包', trigger: 'blur' }],
                  message:[{ required: true, message: '请填写发布信息', trigger: 'blur' }],
                  versionType:[{ required: true, message: '请选择版本类型', trigger: 'change' }]
            }
        }
    },
    created() {
            let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        if(this.$route.query.type == 2){
            this.commentBness({id:this.$route.query.appId},'get')
        }else{
            this.flag = true
        }
    },
    methods: {
        handleRemove1(file, fileList){
            // this.resourceUrl = ""
      },
          uploadError(err,file){
            let errorInfo = JSON.parse(err["message"])
            this.message.error('文件上传失败，原因：' + errorInfo.message) 
          },
        // 子组件触发的方法
        emitFun(val){
            this.form.message = val
        },
           // 上传前获取签名
          beforeUploadFun(file){
            let _self  = this 
            return new Promise((resolve,reject) =>{
                 policy()
            .then(res =>{
             if(res.code == 0){
                if(res.data){
              _self.uploadUrl = res.data.host
              _self.dataObj = {
                policy:res.data.policy,
                signature:res.data.signature,
                ossaccessKeyId:res.data.accessId,
                key:res.data.dir + file.uid + file.name,
                dir:res.data.dir,
                host:res.data.host,
                callback:res.data.callback
              }
              }else{
                _self.uploadUrl = this.$config.baseUrl + '/admin/sys-file/upload'
              }
             }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
             }
             resolve(true)
            })
            .catch(err =>{
               reject(false)
              console.log(err)
            })
            })
          },
          handleAvatarSuccess1(res,file){
            this.form.resourceUrl = res.data.fileId
            this.$refs.ruleForm.clearValidate('resourceUrl')
          },
                 handleChangePic(file,fileList){
       if (fileList.length > 0) {
                     this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
                 }
 },
        // 返回
        reback(){
                this.$router.push({
            name: "Appedition",
            query:{
                id:this.$route.query.id,
                appName:this.$route.query.appName,
                appType:this.$route.query.appType
            }
           })
        },
        onSubmit(formName){
            let params = { ...this.form};
            let method = "post"
            if(this.$route.query.type == 1) params = {...this.form,appId:this.$route.query.id},method = "post";
            if(this.$route.query.type == 2) params = {id:this.$route.query.appId}, method = "get";
               this.$refs[formName].validate((valid) => {
                    if(valid) this.commentBness(params,method)
          }) 
        },
               commentBness(params,method){
                this.loading = true
                appAllfun(params,method)
                        .then(res => {
                            this.loading = false
                           if(res.code == 0){
                            if(this.$route.query.type == 1){
                                this.$message.success('新增成功'); 
                            setTimeout(() => {
                               this.$router.push({
                                name: "Appedition",
                                query:{
                                    id:this.$route.query.id,
                                    appName:this.$route.query.appName,
                                    appType:this.$route.query.appType
                                }
                           })
                             }, 100);
                            }else{
                                this.form = {
                                   versionNum:res.data.versionNum,
                                    resourceUrl:res.data.resourceUrl,
                                    message:res.data.message,
                                    versionType:res.data.versionType
                                }
                                this.appId = res.data.appId
                                this.flag = true
                            }
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                            this.loading = false
                        })
        },
    },
}
</script>
<style lang="scss" scoped>
#addAppediton{
    .edit-from{
        margin-bottom: 44px;
               .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 50%;
        }
        }
                .el-ipt-quill{
            width: 100% !important;
        }
         }
    }
}
</style>